'use client';
import { Link } from '@curology/ui-components-web/react/Link';
import { useSetAtom } from 'jotai';
import React from 'react';

import { LegalModalState } from '@/atoms/termsOfService/legalModalState';
import { AnalyticsEvent, trackEvent } from '@/utils/analytics';

interface LegalLinkProps {
  dataTestId: string;
  title: string;
  src: string;
  type: string;
}

const LegalLink: React.FC<LegalLinkProps> = ({
  dataTestId,
  title,
  src,
  type,
}) => {
  const setDataTestId = useSetAtom(LegalModalState.legalModalDataTestIdAtom);
  const setTitle = useSetAtom(LegalModalState.legalModalTitleAtom);
  const setSrc = useSetAtom(LegalModalState.legalModalSrcAtom);
  const setShowLegalModal = useSetAtom(LegalModalState.showLegalModalAtom);
  const legalLinkClick: React.MouseEventHandler<HTMLDivElement> = (e) => {
    e.preventDefault();
    setDataTestId(dataTestId);
    setTitle(title);
    setSrc(src);
    setShowLegalModal(true);
    trackEvent(AnalyticsEvent.LEGAL_MODAL_OPENED, { type });
  };
  return (
    <Link
      onClick={legalLinkClick}
      className="cur-leading-none cur-rounded-none"
      href="./"
    >
      {title}
    </Link>
  );
};

export default LegalLink;
